module.exports = __webpack_public_path__ + "static/media/notifications-bell.7ef4a702.svg";